// Auto-generated from menu.json
export default {
  "tagName": "ui-menu",
  "types": [
    "placeholder"
  ],
  "attributes": [
    "placeholder"
  ],
  "propertyTypes": {
    "placeholder": "boolean"
  }
};
